import { TheWestSection } from '@news-mono/common'
import { metrics } from '@news-mono/component-library'
import {
    getResolvedTopicPageMeta,
    StaticRoutes,
    Topic,
} from '@news-mono/web-common'
import { layout } from '../../App.routing'

const socialImage = require('./assets/2026_Behind-The-White-Line_Podcast-Tile.jpg')

function getSocialImageMeta(src: string, height: string, width: string) {
    return [
        {
            property: 'og:image',
            content: src,
        },
        { name: 'twitter:image', content: src },
        {
            property: 'og:image:height',
            content: height,
        },
        {
            property: 'og:image:width',
            content: width,
        },
        {
            property: 'og:image:alt',
            content: 'A promotion image for the Behind the White Line Podcast.',
        },
        {
            property: 'twitter:image:alt',
            content: 'A promotion image for the Behind the White Line Podcast.',
        },
    ]
}

export const getBehindTheWhiteLineRouteInfo: StaticRoutes<TheWestSection> = {
    '/podcasts/behind-the-white-line': ({
        getAdTargeting,
        config,
        store,
        resolution,
    }) => {
        const canonicalUrl =
            config.publicUrl + '/podcasts/behind-the-white-line'

        const topic: Topic = {
            id:
                getResolvedTopicPageMeta(resolution)?.id ||
                'podcasts/behind-the-white-line',
            metadata: {},
            title:
                getResolvedTopicPageMeta(resolution)?.title ||
                getResolvedTopicPageMeta(resolution)?.seoTitle ||
                '',
            seoTitle: getResolvedTopicPageMeta(resolution)?.seoTitle || '',
            seoDescription:
                getResolvedTopicPageMeta(resolution)?.seoDescription || ``,
        }

        return {
            kind: 'page',
            heading: topic.title,
            pageType: 'static',
            hideHeading: true,
            refreshOnInactive: false,
            pageMeta: {
                title: topic.title,
                description: topic.seoDescription,
                link: [{ rel: 'canonical', href: canonicalUrl }],
                meta: getSocialImageMeta(socialImage, '630', '1200'),
            },
            socialMeta: {
                title: topic.seoTitle,
                description: topic.seoDescription,
            },
            adTargeting: {
                pageId: 'behind-the-white-line',
                adUnitPath: `${config.baseAdUnitPath}/thewest/podcasts/behind-the-white-line`,
                ssAdUnits: [
                    'WAN',
                    'thewest',
                    'podcasts',
                    'behind-the-white-line',
                ],
                topics: ['podcasts', 'behind-the-white-line'],
            },
            section: 'default',
            compositions: [
                layout.composition({
                    type: 'zeus',
                    props: {
                        containerWidth:
                            metrics.thewest.siteMetrics.mainContentWidth,
                        horizontalGutters: true,
                        hasBackgroundFill: true,
                        stretchSelf: true,
                    },
                    contentAreas: {
                        main: [
                            layout.nestedComposition({
                                type: 'box',
                                props: {
                                    verticalSpacing: 'md',
                                },
                                contentAreas: {
                                    main: [
                                        layout.component({
                                            type: 'podcast-intro-tile',
                                            props: {
                                                podcast:
                                                    'behind-the-white-line',
                                                title: 'Behind the White Line',
                                                description: `An investigation into Australia’s cocaine binge, Behind the White Line, traces the trail of white powder, from narco to nostrils. The series goes inside a $1 billion shipment, exposing a police turf war between the US DEA, the AFP and WA cops over an audacious sting to outwit a Mexican cartel.\n\nWith exclusive interviews of high-ranking detectives, undercover operatives, DEA agents and coke users, Behind the White Line, examines the human cost of the world’s glamour drug hosted by investigative journalist Richard Baker.`,
                                            },
                                        }),
                                        layout.component({
                                            type: 'podcast-subscribe',
                                            props: {
                                                title: 'Behind the White Line',
                                                description:
                                                    'Get notified when each new episode drops, and explore more Australian secrets & true crime by subscribing to the Secrets We Keep podcast.',
                                                listnr: 'https://go.list.nr/foptoj',
                                                apple: 'https://podcasts.apple.com/au/podcast/secrets-we-keep/id1699106866',
                                                spotify:
                                                    'https://open.spotify.com/show/0wJt0WHQ3Cv7a4Z7sY3QSG',
                                            },
                                        }),
                                    ],
                                },
                            }),
                            layout.component({
                                type: 'iframe',
                                props: {
                                    link: 'https://omny.fm/shows/secrets-we-keep/playlists/secrets-we-keep-behind-the-white-line/embed?media=audio&size=wide&style=cover&image=1&description=1&download=1&playlistImages=1&playlistShare=1&share=1&subscribe=1&background=000000&foreground=a3ffe3&highlight=57E4B9',
                                    height: 700,
                                    marginBottom: 'lg',
                                    title: 'Secrets We Keep - Behind the White Line',
                                    allow: 'autoplay; clipboard-write; fullscreen',
                                    allowFullScreen: true,
                                    frameBorder: 0,
                                },
                            }),
                            layout.component({
                                type: 'ad-unit',
                                props: {
                                    noticePosition: 'below-center',
                                    padding: [
                                        0,
                                        0,
                                        metrics.thewest.margins.md,
                                        0,
                                    ],
                                    slot: {
                                        id: 'leaderboard-one',
                                        size: 'leaderboardAbove768MrecBelow',
                                        pageType: 'static',
                                    },
                                    adType: 'inline',
                                },
                            }),
                            layout.component({
                                type: 'lima',
                                props: {
                                    verticalSpacing: 'md',
                                    fontScale: 1.2,
                                    fixedRatios: ['16:9'],
                                    initialColumns: 1,
                                    intermediateColumns: 2,
                                    finalColumns: 4,
                                    hasBackground: true,
                                    loadMoreEnabled: true,
                                    sectionHeader: {
                                        heading: 'Behind the White Line',
                                    },
                                    hasBorder: false,

                                    dataDefinitionArgs: {
                                        type: 'listing',
                                        topics: [
                                            'podcasts/behind-the-white-line',
                                        ],
                                        includeSubTopics: true,
                                        paging: {
                                            page: 1,
                                            pageSize: 8,
                                            pageOffset: 0,
                                        },
                                    },
                                },
                            }),
                        ],
                        sidebar: [
                            layout.component({
                                type: 'ad-unit',
                                props: {
                                    noticePosition: 'below-center',
                                    padding: [
                                        0,
                                        0,
                                        metrics.thewest.margins.md,
                                        0,
                                    ],
                                    slot: {
                                        id: 'sidebar-top',
                                        size: 'desktopMrecHalfPage',
                                        pageType: 'static',
                                    },
                                    adType: 'inline',
                                },
                            }),
                            layout.nestedComposition({
                                type: 'box',
                                props: {
                                    stickyOffset: 350,
                                    fillContainer: true,
                                },
                                contentAreas: {
                                    main: [
                                        layout.component({
                                            type: 'ad-unit',
                                            props: {
                                                noticePosition: 'below-center',
                                                padding: [
                                                    0,
                                                    0,
                                                    metrics.thewest.margins.md,
                                                    0,
                                                ],
                                                slot: {
                                                    id: 'sidebar-middle',
                                                    size: 'desktopMrec',
                                                    pageType: 'static',
                                                },
                                                adType: 'inline',
                                            },
                                        }),

                                        layout.component({
                                            type: 'juliet',
                                            props: {
                                                cardType: {
                                                    type: 'landscape',
                                                    format: 'landscape-smallImage',
                                                },
                                                removeHorizontalGutters: true,
                                                kickerMode: 'hidden',
                                                contentIsTangential: true,
                                                sectionHeader: {
                                                    heading: 'Top Stories',
                                                },
                                                dataDefinitionArgs: {
                                                    type: 'curation',
                                                    name: 'home',
                                                    offset: 0,
                                                    pageSize: 3,
                                                },
                                            },
                                        }),
                                    ],
                                },
                            }),
                        ],
                    },
                }),
            ],
        }
    },
}
